export default __webpack_public_path__ + "static/media/taxi-bg.c6e6b12a.png";